import Highcharts from 'highcharts';
import { INDICATOR_Z_INDEX, PLOT_BAND_WIDTH_PX, SERIES_LINE_WIDTH_PX } from './chartHelpers';
import { INDICATOR_BAND_IDS, INDICATOR_LINE_IDS, type IndicatorBandConfig } from './types';

type ChartWithHiddenIndicators = Highcharts.Chart & {
  hiddenIndicators?: Set<string>;
};

export const setIndicatorHidden = (chart: Highcharts.Chart, indicatorId: string, lineId: string, hidden: boolean) => {
  const chartExt = chart as ChartWithHiddenIndicators;
  if (!chartExt.hiddenIndicators) chartExt.hiddenIndicators = new Set();

  if (hidden) {
    chartExt.hiddenIndicators.add(indicatorId);
    chartExt.hiddenIndicators.add(lineId);
  } else {
    chartExt.hiddenIndicators.delete(indicatorId);
    chartExt.hiddenIndicators.delete(lineId);
  }
};

export const syncIndicatorBands = (chart: Highcharts.Chart, indicators: IndicatorBandConfig[]) => {
  const renderer = chart.renderer as Highcharts.SVGRenderer & {
    [key: string]: Highcharts.SVGElement | undefined;
  };
  const xAxis = chart.xAxis[0];
  const hiddenSet = (chart as ChartWithHiddenIndicators).hiddenIndicators;

  INDICATOR_BAND_IDS.forEach(id => {
    renderer[id]?.destroy();
    renderer[id] = undefined;
  });

  INDICATOR_LINE_IDS.forEach(id => {
    renderer[id]?.destroy();
    renderer[id] = undefined;
  });

  indicators.forEach(indicator => {
    const plotX = xAxis.toPixels(indicator.x, true);

    if (!Number.isFinite(plotX)) return;

    const isHidden = hiddenSet?.has(indicator.id) ?? false;

    renderer[indicator.id] = renderer
      .rect(chart.plotLeft + plotX - PLOT_BAND_WIDTH_PX / 2, chart.plotTop, PLOT_BAND_WIDTH_PX, chart.plotHeight, 0)
      .attr({
        fill: indicator.color,
        zIndex: 0,
        visibility: isHidden ? 'hidden' : 'visible',
      })
      .add();

    renderer[indicator.lineId] = renderer
      .path([
        ['M', chart.plotLeft + plotX, chart.plotTop],
        ['L', chart.plotLeft + plotX, chart.plotTop + chart.plotHeight],
      ])
      .attr({
        stroke: indicator.lineColor,
        'stroke-width': SERIES_LINE_WIDTH_PX,
        'stroke-dasharray': indicator.dashArray,
        zIndex: INDICATOR_Z_INDEX,
        visibility: isHidden ? 'hidden' : 'visible',
      })
      .add();
  });
};
